jQuery(function ($) {
    
    $('[data-bs-toggle="tooltip"]').tooltip();

    $(document).ready(function () {

        //Package Slider on Mobile
        if ($(window).width() <= 768) {  // Adjust the width as needed for mobile
            $("#packageCarousel").lightSlider({
                auto: false,
                loop: true,
                speed: 500,
                pager: false,
                controls: false,
                item: 1.2,
                adaptiveHeight: true,
            });
        }

        $(".line-clamp-4").each(function () {
            let fullText = $(this).text().trim();
            if (fullText.length > 170) {
                let truncatedText = fullText.substring(0, 170) + "...";
                $(this).data("full-text", fullText)
                       .data("truncated-text", truncatedText)
                       .text(truncatedText)
                       .after('<span class="guest-read-more">read more</span>');
            }
        });
    
        $(document).on("click", ".guest-read-more", function () {
            let textSpan = $(this).prev(".line-clamp-4");
            let isExpanded = textSpan.data("expanded");
            textSpan.text(isExpanded ? textSpan.data("truncated-text") : textSpan.data("full-text"));
            $(this).text(isExpanded ? "read more" : "...read less");
            textSpan.data("expanded", !isExpanded);
        });

        $('.accordion').on('show.bs.collapse', function (event) {
            $('.accordion-item').removeClass('active-accordion'); // Remove class from all
            $(event.target).closest('.accordion-item').addClass('active-accordion'); // Add to active item
        });
    
        $('.accordion').on('hide.bs.collapse', function (event) {
            $(event.target).closest('.accordion-item').removeClass('active-accordion'); // Remove when collapsed
        });


        $(".img-accordion img").hide();
        $("#collapseOneImg").show(); // Show the first image by default
    
        $(".accordion-button").on("click", function () {
            // Get the target collapse ID
            let targetId = $(this).attr("data-bs-target"); 
    
            // Extract the image ID corresponding to the clicked accordion button
            let imgId = targetId + "Img"; 
    
            // Hide all images and show the selected one
            $(".img-accordion img").hide();
            $(imgId).fadeIn();
        });


        $('.read-more-wrapper').each(function () {
            var $wrapper = $(this);
            var $resortContent = $wrapper.find('.resort-read-more');
            var $readMoreButton = $wrapper.find('.read-more-btn');
        
            setTimeout(function () {
                var lineHeight = parseFloat($resortContent.css('line-height')) || 20; // Default fallback
                var maxHeight = lineHeight * 10; // Maximum height for 10 lines
        
                // Temporarily set height to 'auto' to get actual full height
                var actualHeight = $resortContent.css('height', 'auto').outerHeight();
        
                // Reset height and apply maxHeight
                if (actualHeight > maxHeight) {
                    $resortContent.css('max-height', maxHeight + 'px');
                    $readMoreButton.show();
                } else {
                    $readMoreButton.hide();
                }
        
                // Reset back to hidden mode
                $resortContent.css('height', '');
            }, 100);
        
            // Toggle expanded state
            $readMoreButton.on('click', function () {
                if ($resortContent.hasClass('expanded')) {
                    $resortContent.removeClass('expanded').css('max-height', (parseFloat($resortContent.css('line-height')) * 10) + 'px');
                    $(this).html('Read More <i class="fa-light fa-chevron-down text-secondary ms-2"></i>');
                } else {
                    $resortContent.addClass('expanded').css('max-height', 'none');
                    $(this).html('Read Less <i class="fa-light fa-chevron-up text-secondary ms-2"></i>');
                }
            });
        });
             
        

        // Event listener for modal closing
        $('#dwenquiry').on('hidden.bs.modal', function () {
            $('#DWEnquiryForm')[0].reset();
        });
        $('#packageEnquiry').on('hidden.bs.modal', function () {
            $('#PackageEnquiryForm')[0].reset();
        });
        
        // Reinitialise tour iframe
        let tourContainer = $('#tour-container');
        if (tourContainer.length) {
            let tourModal = $('#virtualTour');
            let tourContent = tourContainer.html();

            // Show the modal and play the video
            tourModal.on('show.bs.modal', function () {
                // Add the iframe content back to the modal
                $('#virtualTour .modal-body').html(tourContent);
            });

            // Stop the video on modal close
            tourModal.on('hidden.bs.modal', function () {
                $('#virtualTour .modal-body').html('');
            });
        }
        
        // Add a div wrapper to class 'wpcf7-spinner'
        if ($('.wpcf7-spinner').length) { 
            $('.wpcf7-spinner').wrap('<div class="wpcf7-spinner-wrapper"></div>');
        }

        // Check if there are less than 3 slides on desktop

        var slideCount = $('#regionSlider .lslide').length;
        var regionSliderNav = $('.region-slider-nav');

        if ($(window).width() > 1200) {
            if(slideCount > 2) {
                $('#regionSlider').lightSlider('destroy');
            }
            regionSliderNav.hide();
        } else {
            regionSliderNav.show();
            var regionSlider = $('#regionSlider').lightSlider({
                auto: false,
                loop: false,
                pauseOnHover: true,
                keyPress: true,
                speed: 400,
                pause: 5000,
                pager: false,
                controls: false,
                slideMargin: 20,
                item: 3,
                autoWidth: true,
                responsive: [
                    {
                        breakpoint:992,
                        settings: {
                            item: 2,
                            slideMove: 1,
                            autoWidth: true,
                        }
                    },
                    {
                        breakpoint:480,
                        settings: {
                            item:1,
                            autoWidth: true,
                        }
                    }
                ],
                onSliderLoad: function (el) {
                    // This makes the carousel only load after the deferred JS has loaded (after user scroll/interaction)
                    $('.lSSlideOuter').css('opacity', 1);
                }
            });

            $('#regionPrevSlide').on('click', function () {
                regionSlider.goToPrevSlide();
            });

            $('#regionNextSlide').on('click', function () {
                regionSlider.goToNextSlide();
            });
        }


        //REviews Slider on Mobile
        var reviewSlider = $('#review-slider-m').lightSlider({
            auto: false,
            loop: true,
            pauseOnHover: true,
            keyPress: true,
            speed: 400,
            pause: 5000,
            pager: false,
            controls: false,
            slideMargin: 40,
            item: 3,
            responsive: [
                {
                    breakpoint:992,
                    settings: {
                        item: 2,
                        slideMove: 1                        
                    }
                },
                {
                    breakpoint:480,
                    settings: {
                        item: 1
                    }
                }
            ],
            onSliderLoad: function (el) {
                // This makes the carousel only load after the deferred JS has loaded (after user scroll/interaction)
                $('.lSSlideOuter').css('opacity', 1);
            }
        });

        $('#reviewPrevSlide').on('click', function () {
            reviewSlider.goToPrevSlide();
        });

        $('#reviewNextSlide').on('click', function () {
            reviewSlider.goToNextSlide();
        });


        // Bootstrap filter toggle buttons
        $('.btn-group-toggle label').on('click', function () {
            $(this).closest('.btn-group-toggle').find('label').removeClass('active');
            $(this).addClass('active');
        });


        // Prepopulate existing location terms in to CF7 (when they exist)
        if ($('#location-terms').length) {
            // Get the hidden location terms
            let locationTerms = $('#location-terms span');

            let dropdown = $('select[name="location_dropdown"]');
            if (dropdown.length) {
                // Populate the dropdown with the location terms
                locationTerms.each(function () {
                    let term = $(this);
                    let option = $('<option>');
                    option.val(term.data('value'));
                    option.text(term.text());
                    dropdown.append(option);

                    // Check if data-selected-slug and data-selected-name are not empty
                    let selectedSlug = term.data('selected-slug');
                    let selectedName = term.data('selected-name');

                    if (selectedSlug !== '' && selectedName !== '') {
                        // Set the selected option based on data attributes
                        if (option.val() === selectedSlug) {
                            option.prop('selected', true);
                        }
                    }
                });
            }
        }

        $(".readmore-link").click( function(e) {
            // record if our text is expanded
            var isExpanded =  $(e.target).hasClass("expand");
            
            //close all open paragraphs
            $(".package-description.expand").removeClass("expand");
            $(".readmore-link.expand").removeClass("expand");
            $(this).html("Read More <i class='fa-light fa-chevron-down text-secondary ms-2'></i>");  
            
            // if target wasn't expand, then expand it
            if (!isExpanded){
              $( ".package-description" ).addClass( "expand" );
              $(e.target).addClass("expand");
              $(this).html("Read Less <i class='fa-light fa-chevron-up text-secondary ms-2'></i>");    
            } 
        });

        $('.wpcf7-form-control-wrap .wpcf7-not-valid-tip').each(function (index, element) {
            if ($(element).data('validated') !== 'true') {
                // Display the first occurrence of .wpcf7-not-valid-tip
                $(element).show();

                // Mark it as validated
                $(element).data('validated', 'true');
            } else {
                // Hide subsequent occurrences of .wpcf7-not-valid-tip
                $(element).hide();
            }
        });


        //Countdown for Giveaway
        const targetDate = new Date('2024-03-14T00:00:00');

        function updateCountdown() {
          const currentDate = new Date();
          const timeDifference = targetDate - currentDate;
    
          if (timeDifference <= 0) {
            $('#countdown').html('Giveaway entries have now closed!');
          } else {
            const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    
            $('#days').html(`<p class="h2">${days}</p> days`);
            $('#hours').html(`<p class="h2">${hours}</p> hours`);
            $('#minutes').html(`<p class="h2">${minutes}</p> minutes`);
          }
        }
    
        // Update the countdown every second
        setInterval(updateCountdown, 1000);
    
        // Initial update to avoid delay
        updateCountdown();

    });
    if ($('#s-1').length) {
		$('.ew-keyword').click(function(e) {
			e.preventDefault();
			var keywordText = $(this).text();
			$('#s-1').val(keywordText);
			$('#articleSearch').submit();
		});
	}

    
    if ($('body').hasClass('single-package')) {
        $(document).ready(function () {

            //Resort Hero Background slider
            let currentIndex = 0;
            const totalImages = images.length;
            const $slider = $('#heroSlider');
            const $caption = $('#heroCaption');
            let autoSlide;

            // Function to update the slide
            function updateSlide(nextIndex) {
                if (nextIndex >= totalImages) {
                    nextIndex = 0; // Loop back to the first image
                } else if (nextIndex < 0) {
                    nextIndex = totalImages - 1; // Loop to the last image
                }

                // Create a new background div for cross-fading
                let $newBg = $('<div class="hero-bg"></div>').css({
                    'background-image': `url('${images[nextIndex].url}')`,
                    'opacity': 0,
                    'position': 'absolute',
                    'top': 0,
                    'left': 0,
                    'width': '100%',
                    'height': '100%',
                    'z-index': 0,
                    'background-size': 'cover',
                    'background-position': 'center',
                    'transition': 'opacity 1s ease-in-out'
                });

                // Append the new background and fade it in
                $slider.append($newBg);
                setTimeout(() => {
                    $newBg.css('opacity', 1); // Start fade-in after adding to DOM
                }, 50);

                // Remove the old background after fade-in completes
                setTimeout(() => {
                    $slider.find('.hero-bg').first().remove();
                }, 1100); // Match this to the fade duration (1s)

                // Update the caption
                $caption.fadeOut(500, function () {
                    $(this).text(images[nextIndex].caption).fadeIn(500);
                });

                // Update slide indicators
                $('.slide-indicators button').removeClass('active');
                $('.slide-indicators button').eq(nextIndex).addClass('active');

                currentIndex = nextIndex;
            }

            // Function to start auto-slide
            function startAutoSlide() {
                autoSlide = setInterval(function () {
                    updateSlide(currentIndex + 1);
                }, 5000);
            }

            // Function to stop auto-slide
            function stopAutoSlide() {
                clearInterval(autoSlide);
            }

            // Previous and Next buttons
            $('#prevSlide').on('click', function () {
                stopAutoSlide();
                updateSlide(currentIndex - 1);
                startAutoSlide();
            });

            $('#nextSlide').on('click', function () {
                stopAutoSlide();
                updateSlide(currentIndex + 1);
                startAutoSlide();
            });

            // Initialize with the first background
            $slider.css('position', 'relative').append(
                $('<div class="hero-bg"></div>').css({
                    'background-image': `url('${images[0].url}')`,
                    'opacity': 1,
                    'position': 'absolute',
                    'top': 0,
                    'left': 0,
                    'width': '100%',
                    'height': '100%',
                    'z-index': 0,
                    'background-size': 'cover',
                    'background-position': 'center'
                })
            );

            // Initialize slide indicators
            function initSlideIndicators() {
                const $indicators = $('.slide-indicators');
                $indicators.empty(); // Clear existing indicators
                images.forEach((image, index) => {
                    const $indicator = $('<button class="indicator"></button>').attr('data-slide', index);
                    $indicator.on('click', function () {
                        stopAutoSlide();
                        updateSlide(index);
                        startAutoSlide();
                    });
                    $indicators.append($indicator);
                });
                // Set the first indicator as active
                $indicators.find('button').first().addClass('active');
            }

            // Start auto-slide and initialize indicators
            startAutoSlide();
            initSlideIndicators();

        });
    }
});
